<template>
  <div class="problem" v-bind:class="`problem-ID${problem.id}`">
    <div class="container">
      <div>
        <p class="question-sentence">{{problem.question}}</p>
        <div class="answer-buttons-group">
          <div v-for="(answer, i) in problem.answers" v-bind:key="i" class="answer-button-wrapper">
            <button v-on:click="selectAnswer(answer, $event, $event.currentTarget)" v-bind:data-order="i + 1" class="answer-button" v-bind:class="answer.value === selected.answer.value ? 'active' : ''" v-bind:disabled = "getAnswerById(4).label === 'いる' && problem.id === 5">
              <picture>
                <source media="(min-width: 992px)" v-bind:srcset="require(`@/assets/img/pages/index/bg_button_${i + 1 }_medium.png`)" />
                <img v-bind:src="require(`@/assets/img/pages/index/bg_button_${i + 1 }.png`)" class="display-block img-responsive" />
              </picture>
              <span class="answer-button-text">{{answer.label}}</span>
            </button>
          </div>
        </div>
      </div>
      <transition name="slide" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:leave="leave" v-on:after-enter="afterEnter" v-bind:css="false">
        <div v-show="finished && (finishedType === '4') && (problem.id === 4) || finished && (finishedType === '5') && (problem.id === 5)">
          <div class="margin-vert-15px medium-margin-vert-30px">
            <div class="text-center">
              <div class="margin-vert-5px medium-margin-vert-15px margin-horizon-5px margin-bottom-0px">
                <a href="#" v-on:click.stop.prevent="navigate({skip: false})" class="result-button">
                  結果を見る
                  <svg class="result-button-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512">
                    <path fill="currentColor" d="M224.3 273l-136 136c-9.4 9.4-24.6 9.4-33.9 0l-22.6-22.6c-9.4-9.4-9.4-24.6 0-33.9l96.4-96.4-96.4-96.4c-9.4-9.4-9.4-24.6 0-33.9L54.3 103c9.4-9.4 24.6-9.4 33.9 0l136 136c9.5 9.4 9.5 24.6.1 34z" />
                  </svg>
                </a>
              </div>
              <!-- <a href="#" v-on:click.stop.prevent="navigate({skip: true})" class="reslut-text-alink">動画をスキップしたい方はこちら</a> -->
            </div>
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import Answers from "@/model/answers";
import Velocity from "velocity-animate";
import "velocity-ui-pack";

export default {
  name: "ProblemItem",
  computed: {
    selected: function () {
      let ret = {
        id: this.problem.id,
        answer: { name: "", label: "", value: null },
      };
      for (let i = 0; i < this.answers.length; i++) {
        if (this.answers[i].id === this.problem.id) {
          ret = this.answers[i];
        }
      }
      return ret;
    },
  },
  props: {
    problem: {
      type: Object,
    },
    answers: {
      type: Array,
    },
    finished: {
      type: Boolean,
    },
    finishedType: {
      type: String,
    },
  },
  methods: {
    getAnswerById: function(id){
      for (let i = 0; i < this.answers.length; i++) {
        if (this.answers[i].id === id) {
          return this.answers[i].answer;
        }
      }
      return false;
    },
    selectAnswer(answer, $event, currentTarget) {
      const id = this.problem.id;
      const data = {
        id: id,
        answer: answer,
      };
      const self = this;
      currentTarget.classList.add("active");
      Velocity(currentTarget, { scale: 0.98 }, { duration: 0 });
      Velocity(currentTarget, { scale: 1.01 }, { duration: 200 });
      Velocity(
        currentTarget,
        { scale: 1.0 },
        {
          duration: 200,
          easing: "easeOutCubic",
          complete: function () {
            self.$emit("selectAnswer", data);
          },
        }
      );
    },
    navigate(option) {
      const hash = option.skip ? "#skip": "";
      const id = Answers.getResultId(this.answers);
      this.$router.push({
        name: "Result",
        params: { id: id, answers: this.answers, skip: option.skip },
        hash: hash
      });
    },

    beforeEnter: function (el) {
      el.style.opacity = 0;
    },
    enter: function (el, done) {
      el.style.overflow = "hidden";
      el.style.height = "0";
      Velocity(el, { height: `${el.scrollHeight}px` }, { duration: 350 });
      Velocity(el, { opacity: 1 }, { duration: 350, complete: done });
    },
    afterEnter: function (el) {
      el.style.overflow = "";
      el.style.height = "";
    },
    leave: function (el, done) {
      console.log(el, done);
    },
  },
};
</script>
<style lang="scss" scoped>
.problem {
  margin: 0 0 100px;
  flex-grow: 1;
  @media (min-width: 992px) {
    margin: 0 0 150px;
  }
}
.question-sentence {
  font-size: 23px;
  line-height: 1.5;
  margin: 0 0 15px;
  text-align: center;
  color: #e67700;
  letter-spacing: 0.05em;
  @media (min-width: 992px) {
    font-size: 34px;
    margin: 0 0 25px;
    margin: 0 0 35px;
  }
}
.answer-buttons-group {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  margin: 0 auto;
  max-width: 460px;
  @media (min-width: 992px) {
    margin: 0 auto;
    max-width: none;
  }
}
.answer-button-wrapper {
  flex: 0 0 50%;
  max-width: 50%;
  @media (min-width: 992px) {
    flex: 0 0 232px;
    max-width: 232px;
    margin: 0px 30px;
  }
}
.problem-ID2 .answer-button-wrapper {
  @media (min-width: 992px) {
    margin: 0px 10px;
  }
}

.answer-button {
  font-family: inherit;
  background-color: transparent;
  border: none;
  display: block;
  margin: 10px 7px;
  position: relative;
  font-size: 16px;
  background-size: contain;
  cursor: pointer;
  @media (min-width: 992px) {
    margin: 0px;
    max-width: none;
    font-size: 24px;
  }
}
.answer-button-text {
  position: absolute;
  top: 54%;
  left: 0;
  right: 0;
  transform: translateY(-50%);
  @media (min-width: 992px) {
  }
}

@each $order, $color in (1: #1a8ac2, 2: #e96f8e, 3: #e48154, 4: #87c8a1) {
  .answer-button[data-order="#{$order}"] {
    color: $color;
  }
}
@each $order,
  $name in (1: bg_button_1, 2: bg_button_2, 3: bg_button_3, 4: bg_button_4)
{
  .answer-button[data-order="#{$order}"] {
    background-repeat: no-repeat;
    background-image: url("../assets/img/pages/index/#{$name}_on.png");
    @media (min-width: 992px) {
      background-image: url("../assets/img/pages/index/#{$name}_on_medium.png");
    }
  }
}
.answer-button.active {
  color: #ffffff;
}
.answer-button.active img {
  opacity: 0;
}
/*
*/
.result-button {
  background-color: #e67700;
  color: #ffffff;
  display: block;
  margin: 0 auto;
  padding: 12px;
  font-size: 15px;
  text-decoration: none;
  border-radius: 6px;
  text-align: center;
  border: solid 2px #e67700;
  box-shadow: 2px 2px 0 0 rgba(0, 0, 0, 0.2);
  position: relative;
  max-width: 320px;
  @media (min-width: 992px) {
    font-size: 16px;
    max-width: 320px;
  }
}
.result-button:hover {
  background-color: #ffffff;
  color: #e67700;
}
.result-button-icon {
  display: block;
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  right: 10px;
  width: 18px;
  height: 18px;
}
.reslut-text-alink {
  color: inherit;
  margin: 15px auto;
  text-decoration: underline;
  text-align: center;
  font-size: 12px;
  @media (min-width: 992px) {
    font-size: 14px;
  }
}
</style>